"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.post = exports.get = exports.request = exports.applyMiddleware = exports.middlewares = void 0;
var RequestSignatureVerifier_1 = require("../lib/RequestSignatureVerifier");
var http_errors_1 = __importDefault(require("http-errors"));
var isomorphic_fetch_1 = __importDefault(require("isomorphic-fetch"));
require("abortcontroller-polyfill");
exports.middlewares = {
    buildUrl: function (next) {
        return function (url, options) {
            var _a, _b;
            var baseUrl;
            if (typeof window !== 'undefined' && ((_a = window.location) === null || _a === void 0 ? void 0 : _a.href)) {
                baseUrl = new URL(window.location.href);
            }
            if (options.baseURL) {
                if (!options.baseURL.startsWith('https://') &&
                    !options.baseURL.startsWith('/')) {
                    throw new Error("baseURL '".concat(options.baseURL, "' is not absolute; it should start with 'https://' or '/'"));
                }
                baseUrl = new URL(options.baseURL, baseUrl);
            }
            var fullUrl;
            try {
                fullUrl = new URL(url, baseUrl);
            }
            catch (error) {
                if (!options.baseURL) {
                    error.message += ' (note: no baseURL provided)';
                }
                throw error;
            }
            Object.entries((_b = options.params) !== null && _b !== void 0 ? _b : {}).forEach(function (_a) {
                var name = _a[0], value = _a[1];
                if (value === undefined) {
                    fullUrl.searchParams.delete(name);
                }
                else {
                    fullUrl.searchParams.set(name, value);
                }
            });
            return next(fullUrl.toString(), options);
        };
    },
    notOk: function (next) {
        var _this = this;
        return function (url, options) { return __awaiter(_this, void 0, void 0, function () {
            var response, message, detail, _a, _b, _1;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, next(url, options)];
                    case 1:
                        response = _d.sent();
                        if (response.ok) {
                            return [2 /*return*/, response];
                        }
                        message = "".concat(response.status, " ").concat(response.statusText);
                        if (!options.extractErrorMessage) return [3 /*break*/, 5];
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 4, , 5]);
                        _b = (_a = options).extractErrorMessage;
                        return [4 /*yield*/, response.json()];
                    case 3:
                        detail = _b.apply(_a, [_d.sent()]);
                        if (detail) {
                            message = "".concat(message, ": ").concat(detail);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        _1 = _d.sent();
                        return [3 /*break*/, 5];
                    case 5: throw (0, http_errors_1.default)(response.status, "".concat((_c = options.method) !== null && _c !== void 0 ? _c : 'GET', " ").concat(url, ": ").concat(message));
                }
            });
        }); };
    },
    sign: function (next) {
        return function (url, options) {
            var _a;
            if (!options.signatureKey) {
                return next(url, options);
            }
            var method = (_a = options.method) !== null && _a !== void 0 ? _a : 'GET';
            var signer = new RequestSignatureVerifier_1.RequestSignatureVerifier(options.signatureKey, method, url, options.body);
            var headers = new Headers(options.headers);
            headers.set('Authorization', signer.generateAuthorizationHeader());
            return next(url, __assign(__assign({}, options), { headers: headers }));
        };
    },
    timeout: function (next) {
        var _this = this;
        return function (url, options) { return __awaiter(_this, void 0, void 0, function () {
            var controller;
            return __generator(this, function (_a) {
                if (!options.timeout) {
                    return [2 /*return*/, next(url, options)];
                }
                controller = new AbortController();
                setTimeout(function () { return controller.abort(); }, options.timeout);
                try {
                    return [2 /*return*/, next(url, __assign(__assign({}, options), { signal: controller.signal }))];
                }
                catch (error) {
                    throw error.name === 'AbortError'
                        ? new Error('Request timed out')
                        : error;
                }
                return [2 /*return*/];
            });
        }); };
    },
};
function applyMiddleware(fetcher) {
    return Object.values(exports.middlewares).reduceRight(function (chain, middleware) { return middleware(chain); }, fetcher);
}
exports.applyMiddleware = applyMiddleware;
function request(url, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var headers, dispatch, response, body;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    headers = new Headers(options === null || options === void 0 ? void 0 : options.headers);
                    headers.set('Accept', 'application/json');
                    dispatch = applyMiddleware((_a = options === null || options === void 0 ? void 0 : options.fetch) !== null && _a !== void 0 ? _a : isomorphic_fetch_1.default);
                    return [4 /*yield*/, dispatch(url, __assign(__assign({}, options), { headers: headers }))];
                case 1:
                    response = _b.sent();
                    if (!(response.status !== 201)) return [3 /*break*/, 3];
                    return [4 /*yield*/, response.text()];
                case 2:
                    body = _b.sent();
                    try {
                        return [2 /*return*/, JSON.parse(body)];
                    }
                    catch (err) {
                        throw new Error("invalid json response body at ".concat(url, " reason: ").concat(err.message, "; body: ").concat(body.substring(0, 500), "..."));
                    }
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.request = request;
exports.get = request;
function post(url, data, options) {
    return __awaiter(this, void 0, void 0, function () {
        var body, headers;
        return __generator(this, function (_a) {
            body = JSON.stringify(data);
            headers = new Headers(options === null || options === void 0 ? void 0 : options.headers);
            headers.set('Content-Type', 'application/json');
            return [2 /*return*/, request(url, __assign(__assign({ body: body, method: 'POST' }, options), { headers: headers }))];
        });
    });
}
exports.post = post;
exports.default = {
    get: exports.get,
    post: post,
    request: request,
};
//# sourceMappingURL=fetcher.js.map